import { HeaderLayoutConfig } from "@hoa00/i24-core-ui";

export const configLayoutConfig: HeaderLayoutConfig = {
  appName: "Core HRM: Config",
  // backgroundColor: "blue",
  // color: "gray",
};
